var vehicleIconMap = {
  '单钢轮压路机': '压路机.png',
  '单钢轮振动压路机': '压路机.png',
  '压路机': '压路机.png',
  '塔式起重机': '塔式起重机.png',
  '大客车': '大客车.png',
  '客车': '大客车.png',
  '履带式挖掘机': '挖掘机.png',
  '履带式装载机': '装载机.png',
  '履带式起重机': '履带式起重机.png',
  '平地机': '平地机.png',
  '拖泵（柴油）': '拖泵.png',
  '推土机': '推土机.png',
  '汽车起重机': '汽车起重机.png',
  '泵车': '泵车.png',
  '混凝土搅拌运输车': '搅拌车.png',
  '皮卡车': '皮卡车.png',
  '自卸车': '货车.png',
  '装载机': '装载机.png',
  '车载式混凝土泵车': '车载泵.png',
  '轮式挖掘机': '挖掘机.png',
  '轮式装载机': '装载机.png',
  '轮胎式装载机': '装载机.png',
  '轻型载重汽车': '货车.png',
  '随车吊': '随车起重机.png',
  '厢式货车': '货车.png',
  '越野车': '越野车.png',
  '小型普通客车': '小轿车.png'
};
export default function getVehicleIcon(vehicleName) {
  return vehicleIconMap[vehicleName];
}
;